import { connect } from 'react-redux';

import { createNewConversation } from '../../../actions';

import LandingView from './LandingView';

const mapStateToProps = ({ scribeSession: { backendSupport, captioner } }) => ({
  backendSupport,
  user: captioner,
});

const mapDispatchToProps = {
  createNewConversation,
};

export default connect(mapStateToProps, mapDispatchToProps)(LandingView);
